import PropTypes from 'prop-types';
import { TEXT_BASE_EDITING_SOURCE_TYPE } from '../../../../redux/slices/FJSliceRightTextBaseEditing';
import styles from './FJTextBasedEditingRight.module.less';
import FJTextBaseEditVideoRightContainer from '../container/FJTextBaseEditVideoRightContainer';
import FJTextBaseEditAudioRightContainer from '../container/FJTextBaseEditAudioRightContainer';
import FJTextBasedEditingRightTimeLineContainer from '../container/FJTextBasedEditingRightTimeLineContainer';
import FJTextBaseEditingRightHeaderContainer from '../container/FJTextBaseEditingRightHeaderContainer';
import FJBlankInVideoPanel from '../../../FJMainPreview/FJBlankPanel/FJBlankInVideoPanel';
import FJTextBasedEditingConfig from '../../../../config/appConfig/FJTextBasedEditingConfig';

const FJTextBasedEditingRight = ({ sourceType, isBlank }) => {
    if (isBlank) {
        return (
            <FJBlankInVideoPanel
                active={true}
                boxTitle='edit-video-by-editing-text'
                boxDesc='transcribe-your-video-into-editable-text-and-edit-it-just-like-a-document'
                videoUrl={FJTextBasedEditingConfig.notImageBoxVideoUrl}
                bkColor='#f3f3f7'
                // bgUrl={FJTextBasedEditingConfig.notImageBoxBgUrl}
            />
        );
    }

    return (
        <div className={styles.container}>
            <FJTextBaseEditingRightHeaderContainer />
            {sourceType === TEXT_BASE_EDITING_SOURCE_TYPE.VIDEO && <FJTextBaseEditVideoRightContainer />}
            {sourceType === TEXT_BASE_EDITING_SOURCE_TYPE.AUDIO && <FJTextBaseEditAudioRightContainer />}
            <FJTextBasedEditingRightTimeLineContainer />
        </div>
    );
};

FJTextBasedEditingRight.propTypes = {
    sourceType: PropTypes.string.isRequired,
    isBlank: PropTypes.bool.isRequired,
};

export default FJTextBasedEditingRight;
